// extracted by mini-css-extract-plugin
module.exports = {"skills":"CrimeChart_skills__32urc"};